import { api } from '@web-apps/utils-shared'

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    registerUser: builder.mutation<
      void,
      {
        slug: string
        provider?: string
        password?: string
        time_zone?: string
        page_import_id?: string
        is_metapic_referral?: boolean
      }
    >({
      query: (payload) => ({
        path: 'users',
        method: 'put',
        data: payload,
      }),
    }),
  }),
})

export const { useRegisterUserMutation } = authApi
